import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import SplashScreen from "src/components/SplashScreen";
import { setUserData, logout } from "src/actions/accountActions";
import authService from "src/services/authService";
//import { useHistory } from 'react-router';

function Auth({ children }) {
  const dispatch = useDispatch();
  //const history = useHistory();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout()),
      });

      authService.handleAuthentication();

      const user = await authService.loginInWithToken();

      // Verificar passphrase del usuario con localStorage
      if (user && user.user && user.user.passphrase) {
        const storedPassphrase = authService.getPassphrase();
        if (storedPassphrase !== user.user.passphrase) {
          console.log("Passphrase no coincide, deslogueando usuario");
          authService.logout();
          dispatch(logout());
          setLoading(false);
          return;
        }
      }

      await dispatch(setUserData(user));

      console.log({ user });

      // if (authService.isAuthenticated()) {
      //   const user = await authService.loginInWithToken();
      //   await dispatch(setUserData(user));
      // }else{
      //   //El problema de redireccionar aca es que aquellas paginas fuera de la seguridad se van todas al login.
      //   //Pero si no tengo esto, me tira los children aunque no este autenticado. Se handlea desde los AuthGuard.js
      //   //history.push('/');
      // }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  // Efecto para verificar passphrase cada minuto
  useEffect(() => {
    const verifyPassphrase = async () => {
      if (authService.isAuthenticated()) {
        const user = await authService.loginInWithToken();
        if (user && user.user && user.user.passphrase) {
          const storedPassphrase = authService.getPassphrase();
          if (storedPassphrase !== user.user.passphrase) {
            console.log(
              "Passphrase no coincide en verificación periódica, deslogueando usuario"
            );
            authService.logout();
            dispatch(logout());
          }
        }
      }
    };

    const intervalId = setInterval(verifyPassphrase, 180000);

    // Limpiar intervalo al desmontar el componente
    return () => clearInterval(intervalId);
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any,
};

export default Auth;
